import { render, staticRenderFns } from "./vSelect.vue?vue&type=template&id=3b6fce0e&scoped=true&"
import script from "./vSelect.vue?vue&type=script&lang=js&"
export * from "./vSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6fce0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/nisems/front/nisbos-front-admin/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b6fce0e')) {
      api.createRecord('3b6fce0e', component.options)
    } else {
      api.reload('3b6fce0e', component.options)
    }
    module.hot.accept("./vSelect.vue?vue&type=template&id=3b6fce0e&scoped=true&", function () {
      api.rerender('3b6fce0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ls-form/components/saas/vSelect.vue"
export default component.exports